import React, { Fragment, useState } from 'react'
import PropTypes from 'prop-types'

const ViewKeysLink = ({orgKey, secret}) => {
  const [viewKey, toggleViewKey] = useState(false)
  let keys = (
    <Fragment>
      <div>
        Key: <code>{orgKey}</code>
      </div>
      <div>
        Secret: <code>{secret}</code>
      </div>
    </Fragment>
  )
  let icons = viewKey ? 'far fa-eye-slash fa-fw mr-2' : 'far fa-eye fa-fw mr-2'
  return (
    <Fragment>
      <div
        className="btn btn-default btn-myed btn-default-myed btn-sm-myed"
        onClick={() => toggleViewKey(!viewKey)}
      >
        <div className={icons} /> {viewKey ? 'Hide' : 'View'} Keys
      </div>
      {!viewKey ? '' : keys}
    </Fragment>
  )
}

ViewKeysLink.propTypes = {
  orgKey: PropTypes.string,
  secret: PropTypes.string,
}
export default ViewKeysLink
